// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";
// // import "../styles/restricted.css";
// import RestrictedImportPage1 from "../../assets/import-restricted-1.png";
// import  RestrictedImportPage2 from "../../assets/import-restricted-2.png";
// import RestrictedImportPage3 from "../../assets/import-restricted-3.png";
// import RestrictedImportPage4  from "../../assets/import-restricted-4.png";

// const faqData = [
//   {
//     q: "1. What are the prerequisites for applying for Restricted Imports authorisation?",
//         a: (
//         <>
//             <p>To apply for RESTRICTED IMPORTS, the following are required:</p>
//       <ul>
//         <li>Your user profile must be linked with an IEC.</li>
//         <li>
//           A valid DSC must be registered in the system. You may verify the same from My Dashboard  View and Register Digital Signature Token
//         </li>
//       </ul>
            
//             </>
//     ),
//   },
//   {
//     q: "2. What If my IEC is in DEL/canceled/suspended, am I eligible to apply for the authorisation?",
//      a: (
//         <>
//       <ul>
//         <li>If your IEC is in DEL, you shall be allowed to proceed with the submission of your request for issuance of the authorization, however, your application shall only be actioned upon once your IEC is removed from DEL.</li>
//         <li>
// If your IEC is canceled/suspended, you shall not be allowed to proceed with the submission of your request for the issuance of the authorisation.        </li>
//       </ul>
            
//             </>
//     ),
//   },
//   {
//     q: "3. How can I request for withdrawal of my submitted Restricted Imports application?",
//       a: (
//         <>
//             <p>Please follow the below path to withdraw a submitted application</p>
//       <ul>
//         <li>My Dashboard Submitted Applications</li>
//         <li>
// Enter the Type of Scheme (Select in the dropdown: Restricted Imports) and Type of Sub Scheme (Issuance of Restricted Imports Authorisation) Click on Search        </li>
//       <li> Click on Action (Under the Results)  Withdraw</li>
//               </ul>
            
//             </>
//     ),
//   },
//   {
//     q: "4. How can I check the status of my submitted Restricted Imports application?",
//  a: (
//         <>
//             <p>Please follow the below steps to check the status of a submitted application for Restricted Importsn</p>
//       <ul>
//         <li>My Dashboard Submitted Applications</li>
//         <li>
// Enter the Type of Scheme (Select in the dropdown: Restricted Imports) and Type of Sub Scheme (Issuance of Restricted Imports Authorisation) Click on Search        </li>
//       <li>In the search results, please find the status of the submitted application under the column File Status</li>
//               </ul>
            
//             </>
//     ),  },
//   {
//     q: "5. What to do if my application is marked as deficient?",
//     a: (
//         <>
//             <p>If the File Status of your submitted application is marked as deficient, please follow the below steps</p>
//             <br />
//             <p>to respond to the deficiency raised by the officer:</p>
            
//             <ul>
//         <li>My Dashboard  Submitted Applications</li>
//                 <li>Enter Type of Scheme (Select in the dropdown: Restricted Imports) and Type of Sub Scheme (Issuance of Restricted Imports Authorisation)</li>
//               <li>Click on Search</li>
//                 <li>Click on Action (Under the Results) Respond Deficiency</li>
//                 <li>Click on View under the Deficiency view to view the deficiency letter issued by the officer.</li>
//                 <li>To respond to deficiency, click on Respond under the Respond to Deficiency.</li>
//                 <li>A pop-up shall appear asking you Do you want to amend the application? , in case you have to add attachments only, please click on NO whereas, to make changes to your application, please click on YES.</li>
//                 <li>On submission of your response, the life cycle view of the application is updated for your reference and the file are submitted to the RA officer who issued the deficiency letter.</li>
//       </ul>

            
            
//             </>
//     ),
//     },
  
//    {
//     q: "6. Where can we apply for Restricted Imports authorisation? OR Where can we get the link to apply for Restricted Imports authorisation?",
//  a: (
//         <>
//             <p>Please follow the below path to apply for issuance of a Restricted Imports authorisation:</p>
//       <ul>
//         <li>Services  Import Management System</li>
//         <li>
//                  Click on Restricted Imports</li>
//              <li>Click on Apply for Restricted Imports authorisation</li>
//               </ul>
            
//             </>
//         ),
//     },
   
//     {
//         q: "7. Can I import multiple products under a single Restricted Imports authorisation?",
//         a: (
            
//                 <p>Yes but you may only import the item that are listed as a Restricted Item.</p>
//         ),
//             },

//     {
//         q: "8. How long is the Restricted Imports authorisation valid for? OR What is the validity of a Restricted Imports authorisation?",
//         a: (
//             <p>Restricted Imports authorisation shall be valid for imports for 18 months from the date of issuance of the authorisation</p>
//         ),
//     },

//     {
//         q: "9. How and where to enter revalidation period and the other details necessary for applying for Revalidation?",
//         a: (
//             <>
//             <p>Please follow the given path:</p>
//             <ul>
//                 <li>Open the application form, all the details will be available in view-only fields. Only the“Revalidation details” will be editable.</li>
//                 <li>Enter the revalidation period and reason for revalidation • Click on ‘Save and Next’.</li>
//                     <li>Attach the required documents</li>
//                     <li>Tick the declaration form and submit a file for processing</li>
//                 </ul>
//                 </>
//                 ),
            
//     },
    
// ];

// export default function RestrictedImportPage() {
//   return (
//   <>
// <div className="bg-light py-5">
//       {/* LEFT FLOATING */}
//       {/* <div className="left-fixed">
//         <div>FAQ's</div>
//         <div>FTP 2023</div>
//         <div>HBP 2023</div>
//       </div> */}

//       {/* RIGHT BROCHURE */}
//       {/* <div className="brochure">CORPORATE BROCHURE</div> */}

//       {/* WHATSAPP */}
//       {/* <div className="whatsapp">🟢</div> */}
//         <section className="bg-light">
//         <Container>
//           <Row className="g-4 align-items-start">
//             {/* LEFT CONTENT */}
//             <Col lg={8}>
//               <div>
  
//                 <h1>
//             RESTRICTED <span>AUTHORIZATION</span> FOR IMPORT CONSULTANTS IN HYDERABAD
//           </h1>

//           <h2>What Is Restricted Import License?</h2>
//           <p>
//             Import restrictions refer to various tariff and non-tariff barriers imposed by an importing nation to control the volume of goods coming into the country from other countries. Import restrictions are adopted to maintain the exchange rate of the country's currency.
//           </p>

//           <h2>Restrictions For Import:</h2>
//           <p>
//            There are restrictions on imports for various strategic, health, and other reasons. There can be quantitative and qualitative restrictions on imports. If the goods are not banned, the government can give permission/license for specific reasons.
//           </p>

//           <h2>As per Public Notice No. 79/2015-20</h2>
//           <p>
//             New online facility for obtaining import license for restricted items from 18th March 2019. In the line with revised application form ANF – 2M issued vide Public Notice No.79 dated on 15th March 2019. All applicants [individuals, corporate or State/Central entities) are required to use this online facility for filing applications and no application will be accepted in offline mode.
//                 </p>
//                 </div>
//                    </Col>
       
//             <Col lg={4}>
//               <div className="p-4 shadow rounded right-form">
//                 <Form>
//                   <Form.Control className="mb-3" placeholder="Name" />
//                   <Form.Control className="mb-3" placeholder="Email" />
//                   <Form.Control className="mb-3" placeholder="Phone" />
//                   <Form.Control className="mb-3" placeholder="Subject" />
//                   <Button className="w-100">Get Started</Button>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
          
           
//             <section className="bg-light">
//         <Container>
//           <p>
//            Online applications must incorporate mandatory requirements under the relevant Rules and laws, as per the notification please find the below:
//           </p>

//                   <img src={RestrictedImportPage1} alt="Restricted Import" className="img-fluid d-block mx-auto mb-3" />
//                    <img src={RestrictedImportPage2}  alt="Restricted Import" className="img-fluid d-block mx-auto mb-3" />
                
//                   <p>These issues are approved by the competent authority,</p>
                 
//                   <p>To get the license for the import restricted items or want to know more details about the restricted items from the scheme click here (Clickable link for the contact)</p>

                  
//           <p className="note">
//            *Following permanent IEC numbers may be used by non — commercial PSUs and categories or importers/exporters mentioned against each category while applying for import/export licenses:
//           </p>

//                   <img src={RestrictedImportPage3} alt="IEC" className="img-fluid d-block  mx-auto mb-3" />
//                   <img src={RestrictedImportPage4}  alt="IEC" className="img-fluid d-block  mx-auto mb-3"/>

//                   <p>Get more details about the import and export restricted license details</p>
                 
//         </Container>
//       </section>

//       {/* FAQ */}
            
//             <section className="py-5 bg-light faq-section">
//           <Container>
//             <h2 className="mb-4 faq-title">
//             Frequently Asked Questions on Importer-Exporter Code (IEC)/(E-IEC)
//           </h2>

//            <Accordion defaultActiveKey="0" className="custom-faq">
//             {faqData.map((f, i) => (
//               <Accordion.Item eventKey={String(i)} key={i}>
//                 <Accordion.Header>{f.q}</Accordion.Header>
//                 <Accordion.Body>{f.a}</Accordion.Body>
//               </Accordion.Item>
//             ))}
//           </Accordion>
//         </Container>
//         </section>
//         </div>
//     </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaShieldAlt,
  FaIndustry,
  FaExclamationTriangle,
  FaHandsHelping
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";

export default function RestrictedImport() {

  const faqData = [
    {
      q: "Who can apply for Restricted Import License?",
      a: "Any importer holding a valid IEC and dealing with restricted goods can apply.",
    },
    {
      q: "Can I apply with inactive IEC?",
      a: "No, IEC must be active and valid at the time of application.",
    },
    {
      q: "Can multiple products be included?",
      a: "Generally, separate authorization is required for each product category.",
    },
    {
      q: "How long does approval take?",
      a: "Usually 2–6 weeks depending on product type and approvals required.",
    },
    {
      q: "What if application is rejected?",
      a: "You can correct deficiencies and reapply with proper documentation.",
    },
    {
      q: "Where to apply?",
      a: "Applications are submitted online through DGFT portal using ANF-2M form.",
    },
  ];

  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Restricted Import Authorization (DGFT License)
              </h1>

              <p>
                Certain goods cannot be freely imported into India and require
                prior approval from DGFT. This authorization allows businesses
                to legally import restricted goods with full compliance.
              </p>

              <p>
                These goods are not banned but regulated due to safety,
                environmental, or strategic reasons.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is Restricted Import License?
          </h2>

          <p>
            A Restricted Import Authorization is a permission granted by DGFT
            to import goods classified as “restricted” under Foreign Trade Policy.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaShieldAlt className="icon" /> Why Are Imports Restricted?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Protect public health and safety</li>
            <li><FaCheckCircle /> Control environmental impact</li>
            <li><FaCheckCircle /> Regulate sensitive goods</li>
            <li><FaCheckCircle /> Maintain trade balance</li>
          </ul>

          {/* TYPES */}
          <h2 className="section-title">
            <FaList className="icon" /> Types of Restricted Imports
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Animal & biological products</li>
            <li><FaCheckCircle /> Scrap & waste materials</li>
            <li><FaCheckCircle /> Chemicals & industrial goods</li>
            <li><FaCheckCircle /> Defense & sensitive items</li>
            <li><FaCheckCircle /> Aircraft, drones & equipment</li>
            <li><FaCheckCircle /> Precious metals</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Key Documents & Approvals
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> NOC from government departments</li>
            <li><FaCheckCircle /> Pollution control certificates</li>
            <li><FaCheckCircle /> BIS certification</li>
            <li><FaCheckCircle /> DGCA approvals (if applicable)</li>
            <li><FaCheckCircle /> End-user certificate</li>
            <li><FaCheckCircle /> IEC & business documents</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Product classification</li>
            <li><FaCheckCircle /> Documentation preparation</li>
            <li><FaCheckCircle /> DGFT online filing (ANF-2M)</li>
            <li><FaCheckCircle /> Authority review</li>
            <li><FaCheckCircle /> License issuance</li>
          </ul>

          {/* VALIDITY */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Validity of License
          </h2>

          <p>
            License is issued for specific quantity and time period and can be
            extended or revalidated based on conditions.
          </p>

          {/* CHALLENGES */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Common Challenges
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Incorrect product classification</li>
            <li><FaCheckCircle /> Missing approvals</li>
            <li><FaCheckCircle /> Application rejection</li>
            <li><FaCheckCircle /> DGFT delays</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            We provide complete support including classification, documentation,
            DGFT filing, and coordination with authorities to ensure smooth and
            quick approvals.
          </p>

          {/* FAQ */}
          <h2 className="section-title mt-4">Frequently Asked Questions</h2>

          <Accordion defaultActiveKey="0" className="custom-faq">
            {faqData.map((f, i) => (
              <Accordion.Item eventKey={String(i)} key={i}>
                <Accordion.Header>{f.q}</Accordion.Header>
                <Accordion.Body>{f.a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

        </Container>
      </section>
    </div>
  );
}